module.exports = __webpack_public_path__ + "img/bg-grey.4fd57c79.svg";